<template>
  <div class="clinic">
    <!-- 第一层 -->
    <div class="moduleA">
      <div class="moduleATitle">
        <h3>&nbsp;&nbsp;江河云诊所SaaS平台为您提供全方位的服务支持</h3>
        <p>江河云诊所SaaS平台——基层医疗“云时代”的创新平台，集智能诊断、检验、电子化信息管理于一体，包含预约挂号、门诊、检验、治疗理疗、电子病历、药品进销存、连锁管理、营销等一系列功能，是华晟医学为基层医疗机构提供的基于互联网技术的医疗信息化解决方案。</p>
        <p>医疗机构无需购买服务器、软件等额外IT投入、无需繁琐安装，即可满足跨地域、多门店、即开即用的门诊业务财务一体化SaaS服务。我们拥有强大的医学团队、实验室、技术团队支撑，突破传统第三方检验服务断层的壁垒，精准把脉行业趋势，提供更贴心的医疗服务，是一款懂医疗、懂医检、更懂您的智能服务平台!</p>
      </div>
      <div class="moduleAImg">
        <img src="../../../../assets/cpyfw1.png" alt="">
      </div>
    </div>
    <!-- 第二层 -->
    <div class="moduleB">
      <div class="moduleBTitle">
        <p>江河云诊所SaaS平台为您解决一切管理难题</p>
      </div>
      <div class="moduleBContent clearfix">
        <div class="moduleBText">
          <!-- 患者预约管理 -->
          <div class="left">
            <div class="leftContent">
              <img src="../../../../assets/tu1.png" alt="">
              <span>患者预约管理</span>
            </div>
            <p>支持现场、移动平台轻松预约，独享专属就诊时段，实时显示患者当前状态，及时调整，贴心服务</p>
          </div>
          <!-- 患者档案管理 -->
          <div class="left">
            <div class="leftContent">
              <img src="../../../../assets/tu2.png" alt="">
              <span>患者档案管理</span>
            </div>
            <p>建立患者病历库，就诊信息到其消费信息等均自动归档，并帮助诊所搭建对患者诊前、诊中、诊后的全方位服务</p>
          </div>
          <!-- 药品物资管理 -->
          <div class="left">
            <div class="leftContent">
              <img src="../../../../assets/tu3.png" alt="">
              <span>药品物资管理</span>
            </div>
            <p>门诊发药、药品出入库、进销存、库存预警等详情自动统计，清晰把控药品物资动态，药品出入库一键追踪,库存实时查询</p>
          </div>
          <!-- 处方模板管理 -->
          <div class="left">
            <div class="leftContent">
              <img src="../../../../assets/tu4.png" alt="">
              <span>处方模板管理</span>
            </div>
            <p>内置多种处方模板快速调取，支持西药、中药、检验共享模板，并支持自定义配置格式</p>
          </div>
          <!-- 医学检验管理 -->
          <div class="left">
            <div class="leftContent">
              <img src="../../../../assets/tu5.png" alt="">
              <span>医学检验管理</span>
            </div>
            <p>全科检验服务直接对接第三方医学检验实验室，权威可靠的检验数据、实时追踪线上订单检验状态，智能连接检验报告</p>
          </div>
          <!-- 报表分析平台 -->
          <div class="left">
            <div class="leftContent">
              <img src="../../../../assets/tu6.png" alt="">
              <span>报表分析平台</span>
            </div>
            <p>宏观数据的精准营销对比，经营关键指标提示，用数据指导诊所高效运营</p>
          </div>
          <!-- 处方模板管理 -->
          <div class="left">
            <div class="leftContent">
              <img src="../../../../assets/tu7.png" alt="">
              <span>处方模板管理</span>
            </div>
            <p>内置多种处方模板快速调取，支持西药、中药、检验共享模板，并支持自定义配置格式</p>
          </div>
          <!-- 连锁管理平台 -->
          <div class="left">
            <div class="leftContent">
              <img src="../../../../assets/tu8.png" alt="">
              <span>连锁管理平台</span>
            </div>
            <p>支持多种连锁经营模式，实现各分店人财物统一管理，划分不同的操作权限，保证隐私及数据安全</p>
          </div>
        </div>
        <div class="right">
          <img src="../../../../assets/cpyfw2.png" alt="">
        </div>
      </div>
    </div>
    <!-- 第三层 -->
    <div class="moduleC">
      <div class="moduleCTitle">
        <p>江河云诊所SaaS平台为您提供完善的解决方案</p>
      </div>
      <div class="moduleCContent clearfix">
        <div class="left">
          <img src="../../../../assets/cpyfw3.png" alt="">
        </div>
        <div class="moduleCText">
          <!-- 基础免费 -->
          <div class="right">
            <div class="leftCContent">
              <img src="../../../../assets/tu9.png" alt="">
              <span>基础免费</span>
            </div>
            <p>基础诊所功能永久免费</p>
          </div>
          <!-- 连锁医疗 -->
          <div class="right">
            <div class="leftCContent">
              <img src="../../../../assets/tu10.png" alt="">
              <span>连锁医疗</span>
            </div>
            <p>集团化连锁医疗机构业务运营</p>
          </div>
          <!-- 智能诊断 -->
          <div class="right">
            <div class="leftCContent">
              <img src="../../../../assets/tu11.png" alt="">
              <span>智能诊断</span>
            </div>
            <p>诊断经验分享，解锁智能医疗</p>
          </div>
          <!-- 绿色通道 -->
          <div class="right">
            <div class="leftCContent">
              <img src="../../../../assets/tu12.png" alt="">
              <span>绿色通道</span>
            </div>
            <p>智能转诊，专家支持</p>
          </div>
          <!-- 辅助检查 -->
          <div class="right">
            <div class="leftCContent">
              <img src="../../../../assets/tu13.png" alt="">
              <span>辅助检查</span>
            </div>
            <p>智能检索辅助临床精准检查</p>
          </div>
          <!-- 专业售后 -->
          <div class="right">
            <div class="leftCContent">
              <img src="../../../../assets/tu14.png" alt="">
              <span>专业售后</span>
            </div>
            <p>样本接收员和城市服务生上门服务</p>
          </div>
        </div>
      </div>
    </div>
    <!-- 第四层 -->
    <div class="moduleD">
      <p class="moduleP">江河云诊所SaaS平台是您诊所的行医帮手，患者的健康管家</p>
      <div>
        <div class="moduleDSecond clearfix">
          <img src="../../../../assets/cpyfw9.png" alt="" style="width:100%;">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  }
}
</script>

<style lang="scss" scoped>
// 第一层
.moduleA {
  width: 100%;
  height: 922px;
  background: url('../../../../assets/tc828.png') no-repeat;
  background-size: cover;
  margin-top: 84px;
  .moduleATitle {
    padding: 48px 202px 52px 202px;

    h3 {
      font-size: 24px;
      color: #0068b7;
      margin-bottom: 44px;
      text-align: center;
      font-weight: 400;
    }
    p {
      font-size: 15px;
      color: #333333;
      text-indent: 2em;
      line-height: 22px;
      font-weight: 400;
    }
  }
  .moduleAImg {
    width: 100%;
    text-align: center;

    img {
      width: 1136px;
    }
  }
}
// 第二层
.moduleB {
  width: 100%;
  height: 730px;
  padding: 100px 200px 0;
  background-color: #f1f6f7;
  box-sizing: border-box;
  .moduleBTitle p {
    font-size: 24px;
    color: #0068b7;
    text-align: center;
    margin-bottom: 40px;
    font-weight: 400;
  }
  .moduleBContent {
    position: relative;
    .moduleBText {
      width: 60%;
      height: 412px;
      display: inline-block;
      .left {
        float: left;
        padding: 0 30px 22px 0;
        .leftContent {
          padding-bottom: 11px;
          span {
            color: #0068b7;
            font-weight: 400;
          }
          img {
            width: 34px;
            height: 34px;
            vertical-align: middle;
            padding-right: 11px;
          }
        }
        p {
          width: 262px;
          height: 65px;
          font-size: 14px;
          color: #333333;
          font-weight: 400;
        }
      }
    }
    .right {
      position: absolute;
      top: 0;
      right: 30px;
      width: 40%;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
// 第三层
.moduleC {
  width: 100%;
  height: 730px;
  padding: 100px 200px 0;
  background-color: #d8e8f0;
  box-sizing: border-box;

  .moduleCTitle {
    font-size: 24px;
    color: #0068b7;
    text-align: center;
    margin-bottom: 40px;
    font-weight: 400;
  }
  .moduleCContent {
    position: relative;
    .left {
      position: absolute;
      top: 0;
      left: 0;
      width: 40%;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .moduleCText {
      width: 57%;
      height: 380px;
      float: right;
      padding-top: 105px;
      .right {
        float: left;
        padding: 0 22px 22px 0;
        .leftCContent {
          padding-bottom: 11px;
          color: #0068b7;
          font-weight: 400;
          img {
            width: 34px;
            height: 34px;
            vertical-align: middle;
            padding-right: 11px;
          }
        }
        p {
          width: 262px;
          height: 65px;
          font-size: 14px;
          color: #333333;
          font-weight: 400;
        }
      }
    }
  }
}
// 第四层
.moduleD {
  width: 100%;
  height: 600px;
  background-color: #f1f6f7;
  padding: 100px 200px 0;
  box-sizing: border-box;
  position: relative;
  .moduleP {
    font-size: 24px;
    color: #0068b7;
    text-align: center;
    margin-bottom: 74px;
    font-weight: 400;
  }

  .moduleDSecond {
    width: 100%;
    height: 104px;
    text-align: center;
    img {
      width: 1205px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/website/product/component/clinic.vue